import { toast } from "sonner";

/** Convert a `data:<mime>;base64,<payload>` URL into a Blob. */
function dataUrlToBlob(dataUrl) {
  const match = /^data:([^;]+);base64,(.+)$/.exec(dataUrl);
  if (!match) return null;
  const mime = match[1];
  const binary = atob(match[2]);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) bytes[i] = binary.charCodeAt(i);
  return new Blob([bytes], { type: mime });
}

/**
 * Open a receipt (image or PDF) in a new tab. Handles the data: URL case
 * (blocked by browsers as top-level navigation) by converting to a Blob URL,
 * and falls back to a friendly toast if anything fails.
 */
export function openReceipt(url) {
  if (!url) {
    toast.error("Receipt not available");
    return;
  }
  try {
    if (url.startsWith("data:")) {
      const blob = dataUrlToBlob(url);
      if (!blob) throw new Error("Bad data URL");
      const objectUrl = URL.createObjectURL(blob);
      const win = window.open(objectUrl, "_blank", "noopener");
      if (!win) {
        toast.error("Popup blocked — please allow popups for this site to view the receipt");
        return;
      }
      // Revoke after a minute — enough time to render but frees memory
      setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
      return;
    }
    const win = window.open(url, "_blank", "noopener");
    if (!win) toast.error("Popup blocked — please allow popups to view the receipt");
  } catch (e) {
    toast.error("Couldn't open the receipt file. Please contact the admin.");
  }
}
